/** @jsxImportSource @emotion/react */
import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import {
  ConfirmOverlay,
  ConfirmContent,
  ConfirmTitle,
  ConfirmDescription,
  ConfirmButtonsRow,
  CancelButton,
  DeleteButton,
  ErrorText,
} from './confirm-delete.styled';

type Props = {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  isDeleting?: boolean;
  deleteError?: string | null;
  title?: string;
  description?: string;
};

export const ConfirmDeleteModal: React.FC<Props> = ({
  open,
  onCancel,
  onConfirm,
  isDeleting = false,
  deleteError = null,
  title = 'Remove this note?',
  description = "You'll permanently delete it from My Notes.",
}) => {
  return (
    <Dialog.Root open={open} onOpenChange={(o) => !o && onCancel()}>
      <Dialog.Portal>
        <ConfirmOverlay />
        <ConfirmContent aria-describedby={undefined}>
          <Dialog.Title style={{ position: 'absolute', width: 1, height: 1, overflow: 'hidden', clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap' }}>
            {title}
          </Dialog.Title>
          <ConfirmTitle>{title}</ConfirmTitle>
          {description ? <ConfirmDescription>{description}</ConfirmDescription> : null}

          {deleteError && <ErrorText>{deleteError}</ErrorText>}

          <ConfirmButtonsRow>
            <CancelButton type="button" onClick={onCancel} disabled={isDeleting}>
              Cancel
            </CancelButton>
            <DeleteButton type="button" onClick={onConfirm} disabled={isDeleting}>
              {isDeleting ? 'Deleting...' : 'Delete'}
            </DeleteButton>
          </ConfirmButtonsRow>
        </ConfirmContent>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
